import React from "react";
import { Helmet } from "react-helmet";

const OrganizationSchema = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Kinetx Co",
    "url": "https://www.kinetx.co",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.kinetx.co/Kinetx-favicon.webp",
      "width": "512",
      "height": "512"
    },
    "sameAs": [
      "https://www.linkedin.com/company/kinetxco"
    ],
    "description": "Professional IT infrastructure solutions for businesses in Miami and NYC",
    "telephone": "+1-917-719-4889",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "telephone": "+1-917-719-4889",
      "areaServed": ["US", "Miami", "New York City"],
      "availableLanguage": "English"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://www.kinetx.co",
    "name": "Kinetx Co",
    "description": "Advanced IT infrastructure solutions for Miami and NYC businesses"
  };

  // NYC Location
  const nycLocationSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Kinetx Co - New York",
    "image": "https://www.kinetx.co/Kinetx-favicon.webp",
    "url": "https://www.kinetx.co",
    "telephone": "+1-917-719-4889",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "99 Wall St",
      "addressLocality": "New York",
      "addressRegion": "NY",
      "postalCode": "10005",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.7049",
      "longitude": "-74.0088"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "17:00"
    },
    "priceRange": "$$",
    "sameAs": [
      "https://www.linkedin.com/company/kinetxco"
    ]
  };

  // Miami Location
  const miamiLocationSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Kinetx Co - Miami",
    "image": "https://www.kinetx.co/Kinetx-favicon.webp",
    "url": "https://www.kinetx.co",
    "telephone": "+1-917-719-4889",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "35 SW 9th St",
      "addressLocality": "Miami",
      "addressRegion": "FL",
      "postalCode": "33130",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "25.7663",
      "longitude": "-80.1958"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "17:00"
    },
    "priceRange": "$$",
    "sameAs": [
      "https://www.linkedin.com/company/kinetxco"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(nycLocationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(miamiLocationSchema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;

